import useEntityUpdateMode, {
  EntityUpdateModelProps,
  EntityUpdateModelResult,
} from './EntityUpdateModel';

export default useEntityUpdateMode;

export type { EntityUpdateModelProps, EntityUpdateModelResult };
